import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';

import type { NotificationCount } from './requests.models';

@Injectable({ providedIn: 'root' })
export class NotificationsCountApiService {
  #gateway = inject(ApiGateway);

  getCount() {
    return this.#gateway.get<NotificationCount>('notifications/count');
  }
}
